import { Link } from "react-router-dom";
import { MapPin, Heart } from "lucide-react";
import { ACTIVITY_LABELS } from "@/lib/activities";
import { entityTypeLabel } from "@/lib/entityTypes";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgSrc = (u) => (u ? (u.startsWith("http") ? u : `${BACKEND}${u}`) : "");

export default function FarmCard({ farm, onFavorite, isFavorite, onClick }) {
  return (
    <article
      onClick={onClick}
      className="group relative flex flex-col overflow-hidden rounded-[2rem] bg-white border border-[#E5DCD0] shadow-sm transition-all hover:shadow-xl hover:border-[#C8795A]/40 hover:-translate-y-1 cursor-pointer"
      data-testid={`farm-card-${farm.id}`}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={imgSrc(farm.cover_image)}
          alt={farm.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C312E]/50 to-transparent" />
        <div className="absolute top-4 left-4 bg-white/95 backdrop-blur rounded-full px-3 py-1.5 text-xs font-bold text-[#2C312E] flex items-center gap-1.5 shadow-sm">
          <MapPin size={12} strokeWidth={2.5} className="text-[#C8795A]" />
          {farm.city} ({farm.province})
        </div>
        {onFavorite && (
          <button
            onClick={(e) => { e.stopPropagation(); onFavorite(farm); }}
            className="absolute top-4 right-4 bg-white/95 backdrop-blur w-10 h-10 rounded-full flex items-center justify-center shadow-sm hover:scale-110 transition-transform"
            data-testid={`favorite-btn-${farm.id}`}
            aria-label="Aggiungi ai preferiti"
          >
            <Heart
              size={18}
              strokeWidth={2.4}
              className={isFavorite ? "fill-[#C8795A] text-[#C8795A]" : "text-[#58625B]"}
            />
          </button>
        )}
        {farm.distance_km !== undefined && (
          <div className="absolute bottom-4 left-4 bg-[#4A6B53] text-white rounded-full px-3 py-1 text-xs font-bold">
            {farm.distance_km} km
          </div>
        )}
      </div>
      <div className="p-6 flex-1 flex flex-col gap-3">
        <h3 className="font-display font-black text-xl leading-snug text-[#2C312E]">
          {farm.name}
        </h3>
        {entityTypeLabel(farm) && (
          <span className="inline-flex self-start items-center gap-1.5 rounded-full bg-[#4A6B53]/10 text-[#4A6B53] px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider">
            <span className="w-1 h-1 rounded-full bg-[#4A6B53]"/>
            {entityTypeLabel(farm)}
          </span>
        )}
        <p className="text-sm text-[#58625B] line-clamp-2">{farm.description}</p>
        <div className="flex flex-wrap gap-1.5 mt-auto pt-2">
          {(farm.activities || []).slice(0, 3).map((a) => (
            <span
              key={a}
              className="inline-flex items-center rounded-full bg-[#F2EBE1] text-[#4A6B53] px-2.5 py-1 text-[11px] font-bold"
            >
              {ACTIVITY_LABELS[a] || a}
            </span>
          ))}
          {(farm.activities || []).length > 3 && (
            <span className="text-[11px] font-bold text-[#7A7369]">
              +{farm.activities.length - 3}
            </span>
          )}
        </div>
        <Link
          to={`/fattorie/${farm.id}`}
          onClick={(e) => e.stopPropagation()}
          className="inline-flex items-center justify-center rounded-full bg-[#2C312E] text-white px-5 py-2.5 text-sm font-bold hover:bg-[#4A6B53] transition-colors"
          data-testid={`farm-details-${farm.id}`}
        >
          Scopri di più
        </Link>
      </div>
    </article>
  );
}
